import { useCallback, useMemo, useRef, useState } from 'react';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import FJConstant from '../../../../constants/FJConstant';
import FJRetry from '../../../../common/components/FJRetry/FJRetry';
import styles from './FJSubtitleStyleItem.module.less';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import PropTypes from 'prop-types';

const FJSubtitleStyleItem = props => {
    const { url, onItemClick, isSelect = false, isLoadingStyle, videoUrl } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [version, setVersion] = useState(null);
    const [isShowRetry, setIsShowRetry] = useState(false);
    const videoRef = useRef(null);
    const _mouseTimeID = useRef(null);

    const _imageLoaded = () => {
        setIsLoading(false);
        setIsShowRetry(false);
    };

    const _imageError = () => {
        setIsLoading(false);
        setIsShowRetry(true);
    };

    const _onRefreshClick = useCallback(() => {
        setIsShowRetry(false);
        setIsLoading(true);
        setVersion(new Date().getTime());
    }, []);

    const imgUrl = useMemo(() => {
        if (version) {
            return url + '?version=' + version;
        } else {
            return url;
        }
    }, [version, url]);

    const _onClick = () => {
        if (isShowRetry) {
            return;
        }
        onItemClick();

        // 清除预览
        if (_mouseTimeID.current) {
            clearTimeout(_mouseTimeID.current);
            _mouseTimeID.current = null;
        }
    };

    const _videoDidLoad = () => {
        if (videoRef.current && videoRef.current.src) videoRef.current.play();
    };

    const _onMouseEnter = () => {
        if (_mouseTimeID.current) {
            clearTimeout(_mouseTimeID.current);
            _mouseTimeID.current = null;
        }
        // 鼠标停留在自身至少300ms则认为确实鼠标已经进入，避免了来回快速的切入切出
        _mouseTimeID.current = setTimeout(() => {
            playVideo();
        }, 300);
    };

    const _onMouseLeave = () => {
        if (_mouseTimeID.current) {
            clearTimeout(_mouseTimeID.current);
            _mouseTimeID.current = null;
        }
        stopPlayVideo();
    };

    const playVideo = () => {
        if (!videoUrl) return;
        try {
            // 显示video并设置url
            videoRef.current.style.display = 'block';
            videoRef.current.src = videoUrl;
        } catch (e) {
            console.log(e);
        }
    };

    const stopPlayVideo = () => {
        try {
            // 停止播放并隐藏video
            videoRef.current.style.display = 'none';
            videoRef.current.pause();
            videoRef.current.src = '';
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <FJHoverBoardGradation
            className={styles.item_box}
            active={isSelect}
            contentClassName={styles.img_box}
            onClick={_onClick}
            isShowInBorder={true}
        >
            <div className={styles.inner_item} onMouseEnter={_onMouseEnter} onMouseLeave={_onMouseLeave}>
                {isLoading && <div className={styles.placeholder} />}
                <div className={styles.inner}>
                    <img
                        src={imgUrl}
                        draggable='false'
                        onLoad={_imageLoaded}
                        onError={_imageError}
                        loading='lazy'
                        alt=''
                    />
                    <video
                        ref={videoRef}
                        className={styles.video}
                        autoPlay={false}
                        loop={true}
                        muted={true}
                        onLoadedData={_videoDidLoad}
                    />
                    {isLoadingStyle && (
                        <div className={styles.use_loading}>
                            <FJLoading type={FJConstant.WHITE} />
                        </div>
                    )}
                </div>
                <FJRetry refreshCallback={_onRefreshClick} isShow={isShowRetry} />
            </div>
        </FJHoverBoardGradation>
    );
};

FJSubtitleStyleItem.propTypes = {
    url: PropTypes.string,
    onItemClick: PropTypes.func,
    isSelect: PropTypes.bool,
    isLoadingStyle: PropTypes.bool,
    text: PropTypes.string,
    style: PropTypes.object,
    videoUrl: PropTypes.string,
};
export default FJSubtitleStyleItem;
